<template>
  <table id="gameInfo" width="100%" border="0" cellspacing="0" cellpadding="0" :class="getSportBackgroundImage()">
    <template v-if="selectedBettype.sprtId == sportListByKey().N1.sprtId">
      <allBetSoccer></allBetSoccer>
    </template>
    <template v-else>
      <template v-if="!eventAllBet.rbinfo">
        <tbody>
          <tr class="more_bg1">
            <td id="title_showtype" name="title_showtype" class="more_live">
              <template v-if="eventAllBet.rb == 1">
                {{ sportAllBetLang['ALL_BET.LBL_LIVE'] }}
              </template>
              <template v-if="eventAllBet.ha == 'N'">
                <img :src="'assets/images/more_n_'+ langSelected +'.jpg'" class="more_n">
              </template>
            </td>
            <td></td>
            <td class="more_date" >
              <span id="title_date" name="title_date" v-if="selectedMarket != 1">{{ eventAllBet.dt | date('DD / M') }}</span>&nbsp;&nbsp;&nbsp;<span id="title_time" name="title_time">{{ eventAllBet.dt | date('HH:mm') }}</span>
            </td>
          </tr>
          <tr class="more_bg2">
            <td class="mo_bg_1">
              <span id="title_team_h" name="title_team_h" v-html="eventAllBet.tacapt"></span>
            </td>
            <td class="mo_bg_2">&nbsp;V&nbsp;</td>
            <td class="mo_bg_3">
              <span id="title_team_c" name="title_team_c" v-html="eventAllBet.tbcapt"></span>
            </td>
          </tr>
        </tbody>
      </template>
      <template v-else>
        <tbody>
          <tr class="more_bg1">
            <td id="title_showtype" name="title_showtype" class="more_live">
              {{ sportAllBetLang['ALL_BET.LBL_LIVE'] }}
              <template v-if="eventAllBet.ha == 'N'">
                <img :src="'assets/images/more_n_'+ langSelected +'.jpg'" class="more_n">
              </template>
            </td>
            <td></td>
            <td class="more_date">
              <span id="title_date" name="title_date">{{ eventAllBet.dt | date('DD / M') }}</span>&nbsp;&nbsp;&nbsp;<span id="title_time" name="title_time">{{ eventAllBet.dt | date('HH:mm') }}</span>
            </td>
          </tr>
          <tr class="more_bg2">
            <td class="mo_bg_1">
              <span id="title_team_h" name="title_team_h" v-html="eventAllBet.tacapt"></span>
            </td>
            <td class="mo_bg_2">&nbsp;V&nbsp;</td>
            <td class="mo_bg_3">
              <span id="title_team_c" name="title_team_c" v-html="eventAllBet.tbcapt"></span>
            </td>
          </tr>
        </tbody>
      </template>
      <!-- <template v-else-if="selectedBettype.sprtId == sportListByKey().N3.sprtId">
        <allBetTennis></allBetTennis>
      </template> -->
    </template>
  </table>
</template>

<script>
  import DateFilter from '@/vue/filters/date'
  import allBetMixin from '../../../mixins/allBet'
  import EventBus from '@/vue/events/event-bus'

  import allBetSoccer from './all-bet-team-info-sc'
  import allBetTennis from './all-bet-team-info-tn'

  import {
    mapGetters
  } from 'vuex'

  export default {
    mixins: [allBetMixin],
    components: {
      allBetSoccer,
      allBetTennis,
    },
    computed: {
      ...mapGetters([
        'eventAllBet',
        'selectedBettype',
        'selectedMarket',
      ]),

    },
    methods : {
      sportListByKey () {
        return _.keyBy(this.$store.getters.sportList, 'sprtId')
      },
      getSportBackgroundImage () {
        var isRbInfo = this.$store.getters.eventAllBet.rbinfo ? true : false
        switch (this.$store.getters.selectedBettype.sprtId) {
          case this.sportListByKey().N1.sprtId:
            return 'more_bg_table'
          break;
          case this.sportListByKey().G1.sprtId:
            return isRbInfo ? 'more_bg_table_bkr' : 'more_bg_table_bk'
          break;
          case this.sportListByKey().N3.sprtId:
            return isRbInfo ? 'more_bg_table_tnr' : 'more_bg_table_tn'
          break;
          case this.sportListByKey().N21.sprtId:
            return isRbInfo ? 'more_bg_table_vbr' : 'more_bg_table_vb'
          break;
          case this.sportListByKey().N12.sprtId:
            return isRbInfo ? 'more_bg_table_bmr' : 'more_bg_table_bm'
          break;
          // case this.sportListByKey().N20.sprtId:
          //   return isRbInfo ? 'more_bg_table_ttr' : 'more_bg_table_tt'
          // break;
          // case this.sportListByKey().N24.sprtId:
          //   return isRbInfo ? 'more_bg_table_ttr' : 'more_bg_table_tt'
          // break;
          // case this.sportListByKey().N23.sprtId:
          //   return isRbInfo ? 'more_bg_table_bsr' : 'more_bg_table_bs'
          // break;
          case this.sportListByKey().N15.sprtId:
            return isRbInfo ? 'more_bg_table_skr' : 'more_bg_table_sk'
          break;

          default:
            return 'more_bg_table'
          break;
        }
      },
    },
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/all-bet-team-info.vue